// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-user-content{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.delete-modal{
    width: 99% !important;
    border: 2px solid rgb(235, 42, 42) !important
}
.head-card-users.delete-modal{
    background-color: rgb(235, 42, 42) !important;
    width: 100% !important;
}
.cont-info-modal-delete{
    position: relative;
    display: block;
    width: 95%;
    height: 95%;
}
.cont-message-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}
.txt-message-modal-delete{
    font-size: large;
    color: rgb(235, 42, 42);
    letter-spacing: 1px;
}
.cont-user-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 40%;
    justify-content: center;
    align-items: center;
}
.txt-user-modal-delete{
    font-size: x-large;
    color: rgb(51, 51, 51);
    letter-spacing: 1px;
}
.cont-btn-modal-delete{
    position: relative;
    display: flex;
    width: 100%;
    height: 30%;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Auditor/styles/ModalDeleteUSer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB;AACJ;AACA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".modal-user-content{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: #fff;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.delete-modal{\r\n    width: 99% !important;\r\n    border: 2px solid rgb(235, 42, 42) !important\r\n}\r\n.head-card-users.delete-modal{\r\n    background-color: rgb(235, 42, 42) !important;\r\n    width: 100% !important;\r\n}\r\n.cont-info-modal-delete{\r\n    position: relative;\r\n    display: block;\r\n    width: 95%;\r\n    height: 95%;\r\n}\r\n.cont-message-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 30%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.txt-message-modal-delete{\r\n    font-size: large;\r\n    color: rgb(235, 42, 42);\r\n    letter-spacing: 1px;\r\n}\r\n.cont-user-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 40%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.txt-user-modal-delete{\r\n    font-size: x-large;\r\n    color: rgb(51, 51, 51);\r\n    letter-spacing: 1px;\r\n}\r\n.cont-btn-modal-delete{\r\n    position: relative;\r\n    display: flex;\r\n    width: 100%;\r\n    height: 30%;\r\n    justify-content: center;\r\n    align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
